import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import StarIcon from '@material-ui/icons/Star';
import { mediaKitLandingPath } from '../../../../data/staticLandingSlugs';

const MediaKitCard = ({ kit, compact = false }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const to = mediaKitLandingPath(kit.slug);

  return (
    <Card
      component={RouterLink}
      to={to}
      elevation={0}
      sx={{
        height: '100%',
        textDecoration: 'none',
        color: 'inherit',
        borderRadius: 3,
        border: `1px solid ${alpha(primary, 0.14)}`,
        bgcolor: theme.palette.background.paper,
        maxWidth: '100%',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          borderColor: alpha(primary, 0.35),
          boxShadow: `0 14px 36px ${alpha(primary, 0.14)}`,
        },
      }}
    >
      <CardContent sx={{ p: compact ? 2 : 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Chip size="small" label="Programa" color="secondary" sx={{ fontWeight: 700, fontSize: '0.7rem' }} />
          <StarIcon sx={{ fontSize: 16, color: alpha(primary, 0.55) }} />
        </Box>
        <Typography sx={{ fontWeight: 800, fontSize: compact ? '1rem' : '1.12rem', lineHeight: 1.25, mb: 0.75 }}>
          {kit.name}
        </Typography>
        {!compact && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              fontSize: '0.82rem',
              lineHeight: 1.5,
              mb: 1.5,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {kit.metaDescription || `Ver propuesta comercial de ${kit.name}`}
          </Typography>
        )}
        {compact ? (
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>
            /{kit.slug}
          </Typography>
        ) : null}
        <Typography
          component={compact ? 'span' : 'div'}
          sx={{
            fontWeight: 700,
            fontSize: '0.8rem',
            color: primary,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          Ver media kit
          <ArrowForwardIcon sx={{ fontSize: 16 }} />
        </Typography>
      </CardContent>
    </Card>
  );
};

MediaKitCard.propTypes = {
  kit: PropTypes.shape({
    _id: PropTypes.string,
    slug: PropTypes.string,
    name: PropTypes.string,
    metaDescription: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
};

export default MediaKitCard;
